import React, { useEffect } from 'react';
import { Button, Form, message } from 'antd';
import { SaveOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useSEOCreate } from '../../../../hooks/api/SEO';
import { useLayoutContext } from '../../../Layout/context';
import useUnsavedChanges from '../../../../hooks/unsavedChanges';
import Content from '../../../Common/Content';
import PageForm from '../Form';
import { useMessageError } from '../../../../hooks/common';

import styles from './index.module.scss';

export default function PageCreate(): JSX.Element {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const { setBreadcrumbs } = useLayoutContext();
  const seoCreate = useSEOCreate();
  const { setInitData, check, setChanged, contextHolder, isChanged } = useUnsavedChanges();

  useMessageError([seoCreate]);

  useEffect(() => {
    setBreadcrumbs([
      { title: 'Tipping pages', href: '/pages' },
      { title: 'Create page' },
    ]);
  }, []);

  useEffect(() => {
    if (seoCreate.data && !seoCreate.error && !seoCreate.loading) {
      message.success('SEO page create successfully');
      navigate('/pages');
    }
  }, [seoCreate.data, seoCreate.loading]);

  return (
    <>
      <div className={styles.header}>
        <h2>Create SEO page</h2>
        <div className={styles.actions}>
          <Button
            onClick={(e) => {
              e.preventDefault();
              navigate('/pages');
              window.location.reload();
            }}
          >
            Cancel
          </Button>
          <Button
            icon={<SaveOutlined />}
            type="primary"
            onClick={() => {
              form.submit();
            }}
            disabled={!isChanged}
          >
            Save Changes
          </Button>
        </div>
      </div>

      <Content className={styles.content}>
        <Form
          layout="vertical"
          className={styles.main}
          form={form}
          onFinish={(data) => {
            setInitData(data);

            const { categoryId: category, ...values } = data;

            seoCreate.fetch({
              ...values,
              categoryId: typeof category === 'object' ? category.value : category,
            });
          }}
          onChange={() => setChanged(check(form.getFieldsValue()))}
        >
          <PageForm form={form} onChange={() => setChanged(check(form.getFieldsValue()))} />
        </Form>
      </Content>

      {contextHolder}
    </>
  );
}
